export default "__VITE_ASSET__DSg7QFDG__"